import {Outlet} from "react-router-dom";

export default function HealingDetailsTab() {
    return (<Outlet/>);
}
